import React from 'react';

import dotsIllutration from './../../assets/images/static/blueDots.png';
import orangeRing from './../../assets/images/static/ringIllustration.png';

import { industry } from './IndustryList';

import {
  IndustrySection,
  ContentDiv,
  HeadingTitle,
  ProductsWrapper,
  ProductItems,
  ProductImage,
  Image,
  ProductTitle,
  IllutrationSection,
  ImgIllustration,
} from './styled';

const Industry = () => {
  return (
    <IndustrySection id="services">
      <ContentDiv>
        <HeadingTitle>Pick Your Industry</HeadingTitle>
      </ContentDiv>
      <ProductsWrapper>
        {
          industry.map((industry) => (
            <ProductItems 
              key={industry.id}
              className={industry.title}
              >
              <ProductImage>
                <Image 
                  src={industry.src}
                  alt={industry.title} 
                />
              </ProductImage>
              <ProductTitle>{industry.title}</ProductTitle>
            </ProductItems>
          ))
        }
        <ImgIllustration 
          src={dotsIllutration}
          className='hideonMobile'
        />
        <ImgIllustration 
          src={orangeRing} 
          className='showonMobile'
        />
      </ProductsWrapper>
      <IllutrationSection></IllutrationSection>
    </IndustrySection>
  )
}

export default Industry;